<template>
	<div class="pay-record">
		<section class="fx filter-list">
			<div class="fx fx-wrap fx-fill">
				<div class="fx fx-wrap m-l-10">
					<el-date-picker v-model="filterTime" type="daterange" align="left" placeholder="选择日期范围(默认所有)" :picker-options="pickerOptions" @change="initData">
					</el-date-picker>
				</div>
			</div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="请输入门店名称..." @handleSearch="handleOffset(0)"></z-search></div>
			
		</section>
		<section>
			<z-table :offset="params.offset" :count="params.count" :total-count="this.list.total_count" @handleOffset="handleOffset">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in list.list || []">
					<td>
						<span v-if="filterTime && filterTime.length > 0 && filterTime[0]">{{filterTime[0], "YYYY-MM-DD 00:00:00" | momentFmt}} 到 {{filterTime[1], "YYYY-MM-DD 23:59:59" | momentFmt}}</span>
						<span v-else>全部</span>
					</td>
					<td>{{item.name}}</td>
					<td>{{item.pay_fee | filterMoney}}</td>
					<td>{{userInfo.rate}}</td>
					<td>T+{{userInfo.settlement_cycle}}</td>
					<td>{{item, userInfo.rate | chargeResult}}</td>
					<td>{{item, userInfo.rate | settlementResult}}</td>
				</tr>
				<div slot="operate" v-show="list.list && list.list.length > 0">
					<a class="z-btn z-btn-primary b-r-3" @click="handleChoosePageNum()">导出报表</a>
				</div>
			</z-table>
		</section>
		<z-popup :showModel="isPopExport">
			<div slot="popup-cont" class="popup-cont b-r-5">
				<p class="btn-close fx-align" @click="handleCloseExport"><i class="icon-close"></i></p>
				<div class="fx fx-y-center">
					<div class="title fx w80 m-r-5"><span class="fx-fill">选择页码：</span></div>
					<div class="fx-fill">
						<z-select :options="pageNum"class="w150" v-model="pageTarget"></z-select>
					</div>
				</div>
				<P class="p-10">Tip：每页默认500条数据</P>
				<div><a class="btn-down" download="财务报表.csv" @click="handleExportData">确定</a></div>
			</div>
		</z-popup>
	</div>

</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'ReportList',
		components: {},
		data() {
			return {
//				charge: 0,
//				fee: 0,
				isDisableDown: false,//是否继续下载
				isPopExport: false,
				pageNum: [],
				pageTarget: 1,
				columns: ['统计日期', '门店名称', '交易金额（元）', '费率', '结算周期', '手续费（元）', '结算金额（元）'],
				params: {
					offset: 0, //分页偏移量
					count: 10, //每页多少条
					startTime: null, //时间筛选
					endTime: null, //时间筛选
					search: null, //模糊搜索
				},
				filterTime: null,
				pickerOptions: {
					shortcuts: [{
						text: '最近7天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近15天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}]
				}
			}
		},
		mounted() {
			this.initData();
		},
		computed: {
			...mapState({
				list: state => state.payRecord.payReport,
				userInfo: state => state.users.userInfo,
			}),
//			charge: function(total, charge) {
//				return parent(total)*(parent(charge)/1000);
//			}
		},
		filters: {
			//手续费
			chargeResult(item, rate) {
				if (item.pay_fee == 0) return 0;
				let totalFee = (item.pay_fee / 100).toFixed(2);
				return parseFloat(totalFee * rate).toFixed(2);
			},
			
			//结算金额
			settlementResult(item, rate) {
				if (item.pay_fee == 0) return 0;
				let totalFee = (item.pay_fee / 100).toFixed(2);
				let fee = parseFloat(totalFee - (totalFee * rate)).toFixed(2);
				return fee == 0 ? 0 : fee;
			}
		},
		/*
		 * 事件处理
		 */
		methods: {
			handleExportData(e) {
				if (this.isDisableDown) return;
				this.isDisableDown = true;
				
				let param = {
					startTime: this.params.startTime,
					endTime: this.params.endTime,
					pageNum: this.pageTarget,
				};
				this.exportFinanceList(param).then((data) => {
					e.target.href = data;
					e.target.click();
					this.isDisableDown = false;
					this.isPopExport = false;
					this.pageTarget = 1;
				}, (Error) => {
					this.$log(Error);
					this.$toast(Error);
					this.isDisableDown = false;
				})
			},
			
			handleChoosePageNum() {
				this.isPopExport = true;
				
				let param = {
					startTime: this.params.startTime,
					endTime: this.params.endTime
				};
				
				this.getReportCount(param).then((data) => {
					this.pageNum = data;
				}, (Error) => {
					this.$log(Error);
				})
			},
			
			handleOffset(offset) {
				this.params.offset = offset;
				this.initData();
			},
			
			handleCloseExport() {
				this.isDisableDown = false;
				this.isPopExport = false;
				this.pageTarget = 1;
				this.pageNum = [];
			},
			
			initData() {
				if(this.filterTime) {
					this.params.startTime = this.filterTime[0];
					this.params.endTime = this.filterTime[1];
				}
				
				this.getCashierReport(this.params).then((data) => {
					this.$log('请求报表数据成功');
				}, (Error) => {
					this.$log(Error);
				});
			},
			
			...mapActions(['getCashierReport', 'getReportCount', 'exportFinanceList'])
		}
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.pay-record {
		background: $color-white;
		border: 1px solid $color-border;
		border-bottom: none;
		.filter-list {
			padding: px-em(40px);
		}
	}
	
		.popup-cont {
		width: 400px;
		background: #fff;
		transform-origin: 0 -20%;
		padding: 20px;
		.btn-close {
			position: absolute;
			right: -40px;
			top: -0;
			color: #FF0000;
			cursor: pointer;
			border-radius: 50%;
			i {
				transition: all 0.2s ease;
				font-size: 24px;
				color: #fff;
			}
			&:active {
				i {
					transform: scale(0.8);
					color: #ccc;
				}
			}
		}
		.pic-cont {
			width: 360px;
			height: 512px;
			background: #fff url(../../../assets/img/code_mould.png) center center no-repeat;
			background-size: 100%;
			#qrcode {
				background: #fff;
				padding: 10px;
				width: 150px;
				height: 150px;
				position: absolute;
				top: 205px;
				left: 125px;
			}
		}
		.btn-down {
			width: 100%;
			background: $color-main;
			border-radius: 5px;
			display: block;
			color: #fff;
			font-weight: bold;
			font-size: 18px;
			text-align: center;
			padding: 10px 0;
			margin-top: 10px;
			transform: translate(0);
			&:active {
				opacity: 1;
				background: darken($color-main, 5%);
				transform: scale(0.95);
			}
		}
	}
	
	td {
		&.success {
			color: $color-success;
		}
		&.ing {
			color: $color-warning;
		}
		&.fail {
			color: $color-wrong;
		}
	}
	.operat-btn {
	    i,span {
			height: px-em(34px);
			line-height: px-em(34px);
	    }
    }
    @media only screen and (min-width:0px) and (max-width:640px) {
    	.filter-list{
    		display: none;
    	}
	}
</style>


// WEBPACK FOOTER //
// ReportList.vue?734a1fa1